import React from 'react';
import Logo from './Logo';
import { useTranslation } from 'react-i18next';
import { openAnalyticsConsentPreferences } from '../utils/analytics';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-primary border-t border-primary-700">
      <div className="container mx-auto px-4 py-10">
        {/* Üst bölüm: 4 kolon */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Sol: Logo + Açıklama */}
          <div className="space-y-4 text-center md:text-left">
            <Logo color="white" />
            <p className="text-gray-300 text-sm leading-relaxed">{t('footer.tagline')}</p>
          </div>

          {/* İletişim Bilgileri */}
          <div className="text-center md:text-left">
            <h3 className="text-white font-semibold mb-4 text-base">{t('footer.contact_info')}</h3>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-center justify-center md:justify-start gap-2">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href={`tel:${t('demo.info.contact_phone')}`} className="hover:text-white transition-colors">
                  {t('demo.info.contact_phone')}
                </a>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href={`mailto:${t('demo.info.contact_email')}`} className="hover:text-white transition-colors">
                  {t('demo.info.contact_email')}
                </a>
              </div>
            </div>

            {/* İşletme Paneli linki Hızlı Erişim bölümünde var */}
          </div>

          {/* Yasal Sayfalar */}
          <div className="text-center md:text-left">
            <h3 className="text-white font-semibold mb-4 text-base">Yasal</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <a href="/gizlilik-politikasi" className="hover:text-white transition-colors">Gizlilik Politikası</a>
              </li>
              <li>
                <a href="/kullanim-kosullari" className="hover:text-white transition-colors">Kullanım Koşulları</a>
              </li>
              <li>
                <a href="/kvkk-aydinlatma-metni" className="hover:text-white transition-colors">KVKK Aydınlatma Metni</a>
              </li>
              <li>
                <a href="/cerez-politikasi" className="hover:text-white transition-colors">Çerez Politikası</a>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openAnalyticsConsentPreferences}
                  className="hover:text-white transition-colors"
                >
                  Çerez Tercihleri
                </button>
              </li>
              <li>
                <a href="/iptal-iade-kosullari" className="hover:text-white transition-colors">İptal ve İade Koşulları</a>
              </li>
            </ul>
          </div>

          {/* Hızlı Erişim */}
          <div className="text-center md:text-left">
            <h3 className="text-white font-semibold mb-4 text-base">Hızlı Erişim</h3>
            <a
              href="https://panel.pinerandevu.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-sm text-white px-5 py-2.5 border border-white/30 rounded-lg bg-white/10 hover:bg-white/20 transition-colors mb-4"
            >
              İşletme Paneli →
            </a>
            <div className="text-sm text-gray-300 space-y-2">
              <p>
                <a
                  href="https://pinesoftware.net"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-100 font-medium transition-colors"
                >
                  Pine Software
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Alt bölüm: Adres ve Copyright */}
        <div className="border-t border-primary-700 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-300">
            <div className="flex items-center gap-2">
              <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <p>
                <a
                  href="https://alpysoft.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  AlpySoft Dijital Çözümler
                </a>
              </p>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span className="text-center md:text-left">
                Merdivenköy Mah. Dikyol Sok. No.2, Business İstanbul Plaza B179, Kadıköy / İSTANBUL
              </span>
            </div>
            <div className="text-gray-400 text-xs">
              © 2026 Pine Software | AlpySoft. Tüm hakları saklıdır.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
